/** Static fallbacks when API returns null file URLs or missing copy. */
export const PORTAL_BRANDING_DEFAULTS = {
  appLabel: 'Qvara',
  logoColor: '/img/qvara-logo-color.webp',
  logoWhite: '/img/logo-white.png',
  logoIconWhite: '/img/logo-icon-white.png',
  favicon: '/favicon.ico',
  guestBackground: '/img/page-bg.webp',
  guestHeader: 'Welcome back',
  guestText: 'Unified Communications Platform',
  copyrightName: 'PrimeVOX',
  guestHex: '#A855F7',
  buttonHex: '#A855F7',
  sidebarHex: '#18181B',
  sidebarTextHex: '#FAFAFA',
  legalName: 'PrimeVOX Communications, LLC'
} as const
